export default __webpack_public_path__ + "static/media/blackjackLogo.bb884abc.jpg";